const messages = {
  pt: {
    translations: {
      documentTitle: {
        main: 'BaZi by Marina',
        home: 'Análise dos 4 Pilares do Destino (BaZi), I Ching e Feng Shui',
        about: 'Sobre',
        services: {
          main: 'Serviços',
          bazi: 'BaZi',
          iChing: 'I Ching',
          fengShui: 'Feng Shui',
          nineStar: 'Ki das 9 Estrelas',
          dateSelection: 'Seleção de Datas',
        },
        press: 'Imprensa',
        faq: 'Dúvidas',
        contact: 'Contato',
        articles: 'Artigos',
        zodiacAnimals: 'Animais do Zodíaco',
        privacyPolicy: 'Política de Privacidade',
        errorPage: 'Página não encontrada',
      },
      header: {
        home: 'Home',
        about: 'Sobre',
        services: {
          label: 'Serviços',
          bazi: 'BaZi ou Análise dos 4 Pilares',
          iChing: 'I Ching',
          fengShui: 'Feng Shui',
          nineStar: 'Ki das 9 Estrelas',
          dateSelection: 'Seleção de Datas',
        },
        press: 'Imprensa',
        faq: 'Dúvidas',
        contact: 'Contato',
        articles: 'Artigos',
      },
      homePage: {
        banner: {
          title: 'Desvende os padrões por trás da sua data de nascimento',
          ctaButton: 'Confira',
        },
        about: {
          title: 'O que é BaZi?',
          description:
            '<strong>BaZi ou 4 pilares do destino</strong>, ao contrário do que muitas pessoas pensam, é uma ferramenta de autodesenvolvimento, pois ao revelar o nosso padrão de comportamento no mundo, podemos compreender melhor e aos outros.',
          ctaButton: 'Saiba mais',
        },
        horoscope: {
          title: 'Conheça as características do seu signo Chinês',
          ctaButton: 'Descubra agora',
        },
        testimonials: {
          title: 'Depoimentos',
          content: [
            {
              description:
                '"Marina é luz e sabedoria. Essa técnica oriental de "guidance" ainda não conhecida aqui no Brasil e me surpreender com tanta precisão e fez uma ENORME diferença na minha vida. Gratidão e que muitas outras pessoas possam vivenciar o mesmo"',
              author: '<strong>Flavia Marchesini - Miami/EUA</strong>',
            },
            {
              description:
                '"Realizei uma consulta com a Marina, e foi muito bom pois esclareceu questões como profissão, amor, amizades, finanças e também questões ligadas aos meus antepassados, coisa que a astrologia não esclarece. Super recomendo pra quem está buscando esclarecimentos e respostas."',
              author:
                '<strong>Lucas Pereira Bittencourt - Florianópolis/SC</strong>',
            },
            {
              description:
                '"A Marina fez a análise dos meus 4 pilares do Destino, e foi muito útil e interessante. Ela previu alguns eventos com precisão e isso me ajudou a tomar melhores decisões, além de me alertar para ter alguns cuidados com a saúde. Marina é simpática, sabe o que faz e fala com propriedade. É uma excelente profissional. Recomendo!"',
              author: '<strong>Rosemary Khan - Lisboa/PT</strong>',
            },
            {
              description:
                '"Não conhecia os 4 Pilares do Destino, e confesso que me surpreendi com a clareza e precisão das informações contidas em sua análise. Em relação à minha saúde, foi notável como ela identificou e esclareceu alguns sintomas, que até então nenhum exame havia apontado. É um trabalho muitíssimo sério que recomendo!"',
              author: '<strong>Janete Leal - Rio de Janeiro/RJ</strong>',
            },
            {
              description:
                '"Conhecer meus 4 Pilares do Destino foi uma luz. Saber mais sobre os meus antepassados me ajudou a ter mais esclarecimento e me ajudou a entender os caminhos que a vida me colocou e os porquês. Os 4 Pilares e o I Ching também tem me ajudado a aproveitar meu ciclo de “sorte” e me direcionando para um olhar mais cuidadoso quando as coisas não são exatamente como gostaríamos. Marina é sempre muito didática, gentil e delicada, principalmente, ao tocar em alguns pontos porque a nossa vulnerabilidade vem a tona quando abrimos o livro da vida. Sou muito grata por ter conhecido o trabalho da Marina."',
              author: '<strong>Mel Santos - São Paulo/SP</strong>',
            },
          ],
        },
        whoIsMarina: {
          title: 'Marina Caramez',
          description:
            "Meu nome é Marina Caramez e sou <strong>Consultora de Metafísica Chinesa</strong>. A Metafísica Chinesa abrange importantes ciências, tais como os 4 Pilares do Destino, I Ching e Feng Shui. Eu sou graduada nestas três ciências pela Raymond Lo's School of Feng Shui and Destiny em Hong Kong e São Francisco.<br /><br />Utilizando esse conhecimento milenar, meu objetivo é <strong>ajudar os clientes a tomar melhores decisões</strong> em vários aspectos de sua vida, seja negócios, carreira, trabalho, relacionamento ou saúde, para preencher a lacuna entre suas expectativas e realizações",
          ctaButton: 'Saiba mais',
        },
        recentArticles: {
          title: 'Confira os últimos artigos',
          link: 'Veja o artigo completo',
        },
        faq: {
          title: 'Dúvidas frequentes',
          questions: [
            {
              title: '<strong>Como funciona o calendário chinês?</strong>',
              answer:
                'O calendário chinês é lunissolar, ou seja, é baseado nos ciclos da Lua e nos ciclos do Sol, enquanto o calendário ocidental é baseado apenas no do Sol. Para as grandes celebrações, como o Ano Novo chinês, o calendário lunar é utilizado e, por isso, esta data é móvel e geralmente cai entre o final de janeiro e início de fevereiro. Entretanto, o signo do animal regente do ano, sempre começa no início da estação Primavera, geralmente no dia 4 de fevereiro de cada ano.',
            },
            {
              title: '<strong>O que é Feng Shui?</strong>',
              answer:
                'O Feng Shui é uma ciência milenar chinesa que estuda os efeitos das energias do ambiente, natural e construído, sobre as pessoas, sua saúde, seus relacionamentos e sua prosperidade. O principal objetivo do Feng Shui é harmonizar essas energias, tornando os espaços mais aconchegantes ao ficar no escritório ou em casa, em ambientes como quartos, salas, cozinhas, entre outros. Não há espaço em que não se possa trabalhar o Feng Shui.',
            },
            {
              title:
                '<strong>Como o mapa BaZi ou 4 Pilares do destino pode me ajudar?</strong>',
              answer:
                'O mapa BaZi e uma ferramenta de autoconhecimento e análise de destino muito eficaz. Ela é pensada para que possamos antecipar principalmente situações que nos ofereçam desafios, para podermos amenizá-las. Como? Ajustando nossas atividades nestes períodos, e encontrando os melhores momentos para a tomada de decisões importantes.',
            },
            {
              title: '<strong>O que é o Ki das 9 Estrelas?</strong>',
              answer:
                'O Ki das 9 Estrelas é um sistema de astrologia baseado no antigo conhecimento das civilizações chinesa e japonesa que nos ajuda a compreender o nosso perfil psicológico, ou seja, quem realmente somos em nossa essência. Dessa forma aprendemos a agir com mais discernimento e perspicácia para evitar problemas desnecessários no futuro. O mais importante é conhecer a si mesmo. Quando você começa a perceber quem você verdadeiramente é, você começa a entender melhor as outras pessoas, certos acontecimentos, escolhas e muito mais.',
            },
            {
              title: '<strong>Pra que serve o I Ching?</strong>',
              answer:
                'O I Ching é basicamente uma ferramenta para fazer perguntas e obter respostas usada por mais de 5.000 anos pela civilização chinesa. O I Ching nos revela informações sobre o momento presente e tendências futuras, revelando padrões existentes em um determinado momento. Com esse conhecimento em mãos, você tem o livre arbítrio para decidir se segue esses padrões, ou se age, de modo a influenciar a situação numa direção que lhe seja mais favorável.',
            },
          ],
        },
        instagram: {
          title: 'Nos acompanhe no Instagram!',
        },
      },
      articles: {
        title: 'Artigos',
        predictions: 'Previsões',
        disclaimer:
          'Lembre-se que para uma previsão mais precisa, é necessário fazer a análise do seu mapa 4 Pilares do Destino (BaZi).',
        yearOfBirth: 'Ano de Nascimento: ',
        backToArticle: 'Voltar para artigo',
        articleUnavailable: 'Artigo indisponível no momento',
        recentArticlesColumn: {
          title: 'Artigos recentes',
          link: 'Veja o artigo',
        },
        contentFields: {
          career: 'carreira',
          conclusion: 'conclusão',
          love: 'amor',
          health: 'saúde',
        },
      },
      faq: {
        title: 'Dúvidas frequentes',
        questions: [
          {
            title:
              '<strong>Utilizado como oráculo há mais de três mil anos, qual é o diferencial do I Ching quando em comparação com outros métodos de adivinhação e autoconhecimento?</strong>',
            answer: '/videos/pergunta-1.mp4',
          },
          {
            title:
              '<strong>Como você definiria BaZi ou 4 pilares do destino a quem nunca teve contato com esse termo e método?</strong>',
            answer: '/videos/pergunta-2.mp4',
          },
          {
            title:
              '<strong>Diante do seu ponto de vista e experiência profissional, qual é a diferença entre astrologia ocidental e chinesa?</strong>',
            answer: '/videos/pergunta-3.mp4',
          },
          {
            title:
              '<strong>Algumas pessoas costumam relacionar os animais do horóscopo chinês com aqueles associados ao signo ocidental, como por exemplo, Capricórnio e a Cabra ou o Boi e o Touro. Existe alguma correlação entre eles?</strong>',
            answer: '/videos/pergunta-4.mp4',
          },
          {
            title:
              '<strong>Ainda sobre as influências entre métodos e ferramentas, qual seria a definição do Ki das Nove Estrelas?</strong>',
            answer: '/videos/pergunta-5.mp4',
          },
          {
            title:
              '<strong>Novamente sobre o Ki das Nove Estrelas, este possui alguma compatibilidade com o sistema astrológico ocidental? Afinal podemos observar que este também aborda diferentes manifestações energéticas de acordo com a nossa idade, natureza infantil e adulta. O que de forma semelhante acontece entre signo solar e ascendente após o retorno de Saturno por volta dos 30 anos?</strong>',
            answer: '/videos/pergunta-6.mp4',
          },
          {
            title:
              '<strong>Levando em consideração no Ki das 9 Estrelas nos são atribuídas 3 estrelas ao nascer, temos afirmação de que algumas pessoas podem passar a vida toda sem entrar em contato com a sua verdadeira natureza, mantendo-a quase inacessível e vivendo apenas em contato com o seu segundo e terceiro número. Como podemos nos estimular a entrar em contato com o nosso primeiro número, ou seja, a nossa essência?</strong>',
            answer: '/videos/pergunta-7.mp4',
          },
          {
            title:
              '<strong>Em muitas terapias orientais fala-se sobre a importância da boa manipulação do Ki, tem como fortalecer essa energia ou influenciá-la de alguma forma?</strong>',
            answer: '/videos/pergunta-8.mp4',
          },
          {
            title:
              '<strong>Falando sobre Feng Shui, sabemos que existe diversas escolas, algumas delas com opiniões divergentes sobre determinados temas. Como podemos determinar a melhor abordagem para as nossas necessidades? E quais as principais diferenças entre essas escolas?</strong>',
            answer: '/videos/pergunta-9.mp4',
          },
          {
            title:
              '<strong>O fato de vivermos no hemisfério sul, afeta como o Feng Shui deve ser aplicado?</strong>',
            answer: '/videos/pergunta-10.mp4',
          },
          {
            title:
              '<strong>E por fim, aqueles que nunca tiveram contato com quaisquer dos métodos aqui apresentados, qual é o ponto de partida para que alguém realmente inicie o processo de autoconhecimento e aplique mudanças definitivas em sua vida? Supondo que o indivíduo tenha alguma questão pontual na vida pessoal, profissional ou saúde e queria trabalhá-la.</strong>',
            answer: '/videos/pergunta-11.mp4',
          },
        ],
      },
      zodiacAnimals: {
        title: 'Os animais do Zodíaco',
        content:
          'Você conhece o seu signo do zodíaco chinês? A seguir temos os 12 animais ou signos, e seus respectivos anos. Vale observar que <strong>se você nasceu até 03 de fevereiro, o seu signo pertence ao animal do ano anterior.</strong>',
        horoscope: {
          title: 'Confira as previsões de 2024 para cada signo',
          description:
            'Saiba quais são as oportunidades e os desafios que este ano reserva para você!',
          mediaPath: '/images/zodiacAnimals/clouds-mobile.webp',
          ctaButton: 'Saiba mais',
          ctaLink: '/artigos/ano-novo-chines-2024',
        },
      },
      footer: {
        institutional: {
          label: 'Institucional',
          home: 'Home',
          about: 'Sobre',
          press: 'Imprensa',
          faq: 'Dúvidas',
          contact: 'Contato',
          zodiac: 'Os animais do Zodíaco',
          articles: 'Artigos',
          privacyPolicy: 'Politica de privacidade',
        },
        services: {
          label: 'Serviços',
          bazi: 'BaZi ou Análise dos 4 Pilares',
          iching: 'I Ching',
          fengshui: 'Feng Shui',
          ki: 'Ki das 9 Estrelas',
          dateselection: 'Seleção de Datas',
        },
        contact: {
          label: 'Contatos',
        },
        copyright:
          '© {{currentYear}}. BaZi by Marina. Todos os direitos reservados. Desenvolvido por',
      },
      aboutPage: {
        title: 'Sobre',
        marina: {
          description:
            'Consultora de Metafísica Chinesa, Marina Caramez é graduada pela Raymond Lo’s School of Feng Shui and Destiny em Hong Kong e São Francisco, onde foi aluna do Grand Master Raymond Lo, um dos 5 mestres mais importantes da Ásia.<br /><br />Apesar de ter iniciado sua carreira na área de direito, ela descobriu sua paixão pela fotografia alguns anos depois. Curiosamente, foi através esse hobby que encontrou o seu caminho. Em 2012, ela se mudou para Hong Kong, onde viveu por 4 anos, e veio a conhecer a Metafísica Chinesa.<br /><br /><strong><i>”Fotografando o cenário urbano de Hong Kong, Xangai, Beijing e outros grandes centros urbanos na Ásia, pude observar certas peculiaridades na arquitetura, tanto clássica quanto moderna, e todas elas estavam relacionadas ao Feng Shui.”</i></strong><br /><br />Marina continua estudando e desenvolvendo suas técnicas dentro da metafísica chinesa.',
        },
        mission: {
          title:
            'Marina é formada na China, com um dos 5 mestres mais importantes da Ásia',
          description:
            'Utilizando todo esse conhecimento milenar adquirido por Marina, surgiu a marca BaZi by Marina, que, por meio da Metafísica Chinesa, tem como objetivo <strong>ajudar os clientes a tomar melhores decisões em vários aspectos de sua vida, seja negócios, carreira, trabalho, relacionamentos ou até saúde, a fim de preencher a lacuna entre suas expectativas e realizações.</strong><br /><br />Esse conhecimento também fornecerá orientação para que você encontre as suas próprias respostas, que sem dúvida nenhuma é o ponto de partida para qualquer desenvolvimento pessoal.',
        },
      },
      services: {
        defaultTitle: 'Serviços',
        alternativeTitle: 'Veja outros serviços',
        content: [
          {
            title: 'BaZi ou Análise dos 4 Pilares do Destino',
            description:
              'Além de promover o aprimoramento pessoal, o <strong>BaZi</strong> revela as próximas tendências (positivas ou negativas), colocando você um passo à frente dos eventos.',
            icon: '/icons/kanji-bazi-red.svg',
          },
          {
            title: 'I Ching',
            description:
              'O <strong>I Ching</strong> é uma ferramenta usada para prever eventos que irão governar nosso destino, fornecendo respostas e orientação para nossas perguntas.',
            icon: '/icons/kanji-iching-red.svg',
          },
          {
            title: 'Feng Shui',
            description:
              '<strong>Feng Shui</strong> é essencialmente a interação dos humanos e seus ambientes. A intenção é trazer harmonia ao lar e ao meio ambiente e, ao fazê-lo, à pessoa também.',
            icon: '/icons/kanji-fengshui-red.svg',
          },
          {
            title: 'Ki das 9 Estrelas',
            description:
              '<strong>Nine Star Ki</strong> é uma ferramenta para nos tornarmos conscientes de nossa verdadeira essência e compreender nossos padrões de comportamento, mas o mais importante, mostra como é único ser você!',
            icon: '/icons/kanji-ninestar-desktop-red.svg',
          },
          {
            title: 'Seleção de Datas',
            description:
              'A <strong>Seleção de Datas</strong> te ajuda a identificar o momento mais favorável para você planejar, executar ou embarcar em uma jornada em direção àquilo que você mais deseja.',
            icon: '/icons/kanji-date-red.svg',
          },
        ],
        ctaButton: 'Saiba mais',
        timeline: [
          {
            year: '2013',
            content:
              '<strong>Formação em Feng Shui e Metafísica Chinesa em Hong Kong com Grand Masters Raymond Lo, um dos 5 mestres mais importantes da Ásia</strong>',
          },
          {
            year: '2018',
            content:
              '<strong>Formação em Metafísica Chinesa Avançada em São Francisco</strong>',
          },
          {
            year: '2019',
            content: '<strong>Criação da marca BaZi by Marina</strong>',
          },
          {
            year: '2020',
            content:
              '<strong>Especialização em BaZi com o Grand Master Lily Chung</strong>',
          },
          {
            year: '2021',
            content:
              '<strong>Formação em Astrologia do Ki das 9 Estrelas pela Feng Shui Academy em Lisboa</strong>',
          },
          {
            year: '2022',
            content:
              '<strong>Especialização em Seleção de Datas com Richard Ashworth, um dos mais respeitados Mestres de Metafísica Chinesa no Ocidente</strong>',
          },
        ],
      },
      servicePages: {
        iChing: {
          title: 'I Ching',
          understandingIChing: {
            title: 'Entendendo o I Ching',
            kanjiPath: '/icons/kanji-iching-red.svg',
            description:
              'O I Ching é basicamente uma ferramenta para fazer perguntas e obter respostas usada por mais de 5.000 anos pela civilização chinesa.<br /><br /><strong>O I Ching nos revela informações sobre o momento presente e tendências futuras.</strong><br /><br />Esse conhecimento milenar é capaz de revelar padrões existentes em um determinado momento.<br /><br /><strong>Ao esclarecer esses padrões (situação atual e tendência futura), você tem o livre arbítrio para decidir se segue esses padrões, ou se age, de modo a influenciar a situação.</strong>',
            mediaPath: '/images/iChing/marina-holding-iching-card.webp',
          },
          howItHelps: {
            title: 'O I Ching nos ajuda a agir',
            description:
              '<strong>A beleza do I Ching é que ele nos ajuda a agir.</strong> Ele inicia um processo que nos leva a determinar as melhores ações a serem tomadas em relação à situação que estamos enfrentando.<br /><br />Muitas vezes me perguntam quando se deve consultar o I Ching. Digo que quando hesitamos sobre um caminho a seguir, ou temos um dilema a resolver, podemos usá-lo para o que realmente é: uma ferramenta para ajudar a tomar decisões. Visto que vivemos em um mundo de profundas e constantes mudanças, é um privilégio poder acessar tais informações para um melhor julgamento.',
            mediaPath: 'https://www.youtube.com/embed/vijlKd3aoaY',
            ctaButton: 'Fale conosco',
          },
          formTitle: 'Obtenha a orientação que você precisa',
        },
        BaZi: {
          title: 'BaZi ou os 4 Pilares do Destino',
          destinyCode: {
            title: 'Código do Destino',
            kanjiPath: '/icons/kanji-bazi-red.svg',
            description:
              'O termo BaZi 八字 ou 4 Pilares do Destino vem do formato do mapa astrológico, que assume a configuração de 4 Pilares, com 8 Caracteres Chineses.<br /><br />Na astrologia chinesa, <strong>o dia do seu nascimento se comporta como a sua impressão digital no mundo</strong> - ela conta uma história específica. Essa data e hora de nascimento formarão o que chamamos de <strong>“Mapa Quatro Pilares”</strong>.<br /><br />Os pilares são respectivamente <strong>o ano, o mês, o dia e a hora do seu nascimento</strong>, e representam seus dons, talentos, lições e desafios na vida.',
            appendix:
              'Este mapa descreve a sua trajetória na vida e os eventos que estão reservados para você no futuro. É bom frisar que tais eventos são predeterminados até certo ponto, pois podem ser modificados pelos efeitos de suas decisões.<br /><br />Ao compreender melhor a si mesmo e a energia e lições com as quais nascemos, é possível escolher conscientemente de forma diferente. Ter acesso a estas informações nos dá a oportunidade de mudar certos aspectos em nós mesmo e, no processo, mudar o resultado final e crescer como indivíduo.<br /><br />Resumindo, a Análise de Destino nos permite investigar o mistério por trás de nosso propósito de vida, nossos talentos, personalidade, pontos fortes e fracos. <strong>A premissa básica do BaZi é ajudá-lo a entender a sua impressão digital espiritual</strong>, para que você possa se equipar com conhecimento e o poder necessários para direcionar seu destino em qualquer direção que desejar!',
          },
          zodiacCarousel: {
            title: 'Os animais do Zodíaco',
          },
          baziPrecision: {
            title: 'Qual é a precisão da análise do BaZi?',
            description:
              'A possibilidade de duas pessoas nascerem com um mapa BaZi idênticos são de 1 em 12,96 milhões. Além disso levará outros 240 anos para que no próximo ciclo tenhamos outro mapa BaZi idêntico.<br /><br />Com essas informações em mente, é possível compreender a complexidade, detalhamento e diferenciação em relação aos cálculos, portanto, há enorme precisão neste método para revelar as informações contidas no próprio destino.',
            mediaPath: 'https://www.youtube.com/embed/SRZ6ZnVDvAw',
            ctaButton: 'Fale conosco',
          },
          formTitle: 'Conheça o que o destino tem reservado pra você',
        },
        nineStar: {
          title: 'Ki das 9 Estrelas',
          thePowerOfNineStar: {
            title: 'O poder do Ki das 9 Estrelas',
            kanjiPath: '/icons/kanji-ninestar-mobile-red.svg',
            description:
              'O Ki das 9 Estrelas é possivelmente o mais antigo sistema de astrologia do mundo, e é baseado no antigo conhecimento das civilizações chinesa e japonesa.<br /><br />Ki (termo japonês), também conhecido como Chi ou Qi (termos chineses), <strong>refere-se à força vital ou energia universal.</strong><br /><br />Esse sistema está intimamente relacionado ao I Ching- o Livro das Mutações, que tem mais de 4.000 anos e cujos princípios são a base da teoria do Yin e Yang, dos 5 Elementos, da Medicina Tradicional Chinesa e do Feng Shui.',
            mediaPath: '/images/nineStar/calendar.webp',
            appendix:
              'No Ki das 9 Estrelas, lhe serão atribuídas três estrelas ao nascer. <strong>A energia dessas estrelas fornece a você várias características e qualidades formando assim a sua Assinatura Energética do Ki das Nove Estrelas.</strong> São elas:',
          },
          signatureTabs: [
            [
              'Personalidade',
              'Fornece informações sobre quem você é realmente e qual o seu propósito, ou seja, <strong>qual é a sua missão aqui</strong>. A primeira estrela que você recebe denota sua essência, sua verdadeira natureza na fase adulta. Essa natureza não se manifestará até que você tenha passado por dois ciclos de 9 anos - só após os 18 anos você começa a emergir como um indivíduo independente. Algumas pessoas podem passar a vida toda sem entrar em contato com sua verdadeira natureza, mantendo-a quase inacessível e vivendo apenas em contato com o segundo ou terceiro número.',
            ],
            [
              'Infância',
              '<strong>Ele fala sobre sua natureza emocional e dependente, infância e a maneira como você se comunica</strong> (portanto, é muito importante em relacionamentos íntimos). A maioria dos adultos vive de acordo com sua primeira natureza, a adulta, tendo a sua segunda natureza - a da infância - emergindo quando estão emotivos (felizes, animados, etc.) ou sob estresse.',
            ],
            [
              'Ações',
              'Essa estrela fornece informações sobre como os outros o veem. <strong>É a sua personalidade externa.</strong> Além disso, <strong>revela sua maior força e seu maior desafio na vida.</strong> Às vezes pode não ser um reflexo verdadeiro de quem você é, mas é a 1ª impressão que as pessoas têm de você. Alguns relacionamentos pessoais podem fracassar quando a atração inicial é baseada na natureza da 3ª estrela e não da primeira, que reflete a sua verdadeira natureza.',
            ],
          ],
          whyNineStarPartOne: {
            title: 'Por que consultar o Ki das 9 estrelas?',
            description:
              'O Ki das Nove Estrelas é inestimável para nos ajudar a entrar em contato com nossa natureza básica e condicionada, com todos os seus pontos fortes e fracos.<br /><br /><strong>As pessoas estão recorrendo ao Nine Star Ki para entender seu verdadeiro potencial, habilidades naturais e capacidade de liderança</strong> - perguntando o que me faz agir? O que nasci para fazer? O Ki das Nove Estrelas também o ajudará a entender mais sobre sua saúde e como você responde às mudanças e ao stress.',
            mediaPath: '/images/nineStar/singularity.webp',
          },
          whyNineStarPartTwo: {
            description:
              'Também vai compreender por que realizar certas tarefas é mais natural do que outras e como voltar aos trilhos se estiver fora de equilíbrio.<br /><br /><strong>Sem dúvida nenhuma o Ki das 9 Estrelas é uma ferramenta para nos tornarmos conscientes de nossas tendências energéticas, compreender nossos padrões de comportamento e melhor administrar nosso futuro e destino!</strong>',
            mediaPath: '/images/nineStar/certificate.webp',
            ctaButton: 'Faça sua avaliação',
          },
          formTitle: 'Entenda sua verdadeira essência',
          badgeList: {
            title: 'Assinatura Energética do Ki das 9 Estrelas',
            badges: [
              ['Personalidade', '/images/badges/nineStar/personalidade.webp'],
              ['Infância', '/images/badges/nineStar/infancia.webp'],
              ['Ações', '/images/badges/nineStar/acoes.webp'],
            ],
          },
        },
        fengShui: {
          title: 'Feng Shui',
          understandingFengShui: {
            title: 'Entenda o Feng Shui',
            kanjiPath: '/icons/kanji-fengshui-red.svg',
            description:
              'O Feng Shui começou inicialmente como um conjunto de princípios que foram usados para determinar os locais mais adequados para se construir uma aldeia, <strong>observando o ambiente natural a sua volta.</strong> Esta relação foi considerada o único fator determinante para saber se uma comunidade prosperaria (por viver em harmonia com seu ambiente natural), ou apenas sobreviveria (por trabalhar contra as forças da natureza e não viver em harmonia com seu ambiente natural).<br /><br />Portanto, <strong>Feng Shui é o estudo de como a energia ou Qi em nossas casas ou escritórios nos afetam.</strong> As técnicas do Feng Shui nos permitem mitigar as influências negativas enquanto realçamos as positivas.',
            mediaPath: 'https://www.youtube.com/embed/czAuTx4v7Ys',
            appendix:
              '“Feng” significa vento e “Shui” significa água. <strong>Feng - o vento, refere-se ao Qi invisível ou intangível que flui por um espaço. Shui - a água, é o fluxo visível e mais tangível de energia.</strong><br /><br />Feng Shui é essencialmente o estudo da relação dos humanos com seu meio ambiente. Este estudo permite influenciar essas energias com o objetivo de se obter melhor qualidade de vida.<br /><br />O Feng Shui pode ser aplicado a todos os espaços onde as pessoas vivem, trabalham e interagem.',
          },
          whatIsKi: {
            title: 'O que é Qi',
            description:
              'Qi é energia no sentido mais amplo possível. <strong>O Qi abrange todas as manifestações de energia, desde os aspectos mais materiais da energia</strong> (como a terra sob seus pés, seu computador e o seu próprio corpo), <strong>até os aspectos mais imateriais</strong> (luz, movimento, calor, impulsos nervosos, pensamento e emoção).<br /><br /><strong>A vida, é uma fusão de diferentes tipos de Qi.</strong> Um ser humano saudável (e feliz) é uma composição dinâmica, no entanto harmoniosa, de todos os aspectos do Qi que o constitui.<br /><br />O Qi está em um estado de fluxo permanente, transformando-se continuamente. Não é criado nem destruído; simplesmente muda em sua manifestação.',
            mediaPath: '/images/fengShui/blueprint.webp',
          },
          whatToExpect: {
            title: 'O que esperar de um consultor de Feng Shui',
            description:
              'O trabalho de um consultor de Feng Shui constitui em identificar energias positivas e negativas em uma propriedade e sugerir estratégias/soluções para o equilíbrio de ambas.<br /><br />Em cada projeto de Feng Shui, <strong>avaliarei o espaço fisico tanto pessoalmente quanto remotamente</strong>, dependendo da situação, identificando as energias positivas e negativas que afetam a propriedade.<br /><br />Com isso posso definir o melhor aproveitamento do fluxo energético, maximizando as positivas e minimizando as negativas (aplicação de curas)',
            mediaPath: '/images/fengShui/marina-consultant.webp',
            ctaButton: 'Faça sua avaliação',
          },
          formTitle: 'Crie um lar saudável',
          badgeList: {
            title: 'Levarei em consideração:',
            badges: [
              ['O meio ambiente', '/images/badges/fengShui/ambiente.webp'],
              [
                'A forma e a direção da propriedade',
                '/images/badges/fengShui/forma.webp',
              ],
              ['O fator tempo', '/images/badges/fengShui/tempo.webp'],
              ['Os residentes', '/images/badges/fengShui/residentes.webp'],
            ],
          },
          bonusServices: {
            title: 'Ao final, você irá receber:',
            bonusList: [
              [
                '/icons/ellipse.svg',
                'Relatório fornecido eletronicamente dentro de até 15 dias úteis, incluindo referências de materiais/cores, observações e recomendações.',
              ],
              [
                '/icons/ellipse.svg',
                'A planta baixa com a discriminação dos setores auspiciosos relacionados a carreira, dinheiro, relacionamentos, saúde e riqueza.',
              ],
              [
                '/icons/ellipse.svg',
                'Análise dos 4 Pilares para 1-2 residentes (sessão de 1 hora online).',
              ],
            ],
          },
        },
        dateSelection: {
          title: 'Seleção de Datas',
          auspiciousSelection: {
            title: 'Seleção de data auspiciosa',
            kanjiPath: '/icons/kanji-date-red.svg',
            description:
              'O conceito de <strong>Seleção de Data</strong> se refere a realizar uma atividade no período em que as energias do Universo estão favoráveis para aquele determinado empreendimento.<br /><br />Os chineses acreditavam que há um momento perfeito para realizar uma atividade específica onde a energia do céu e da terra estão em harmonia.<br /><br /><strong>Através da observação das leis da natureza e da astronomia</strong>, os povos da China antiga criaram um sistema em que eram capazes de identificar certos dias do ano em que os eventos podem ocorrer sem problemas, e os usavam para realizar atividades ou empreendimento com sucesso.<br /><br /><strong>Escolher o dia perfeito para ocasiões importantes faz toda a diferença.</strong> Os marcos da vida criam memórias. Essas memórias nós carregamos ao longo da nossa existência, e quando positivas, têm o poder de nos impulsionar ainda mais.',
            mediaPath: '/images/dateSelection/marina.webp',
          },
          aPowerfulTool: {
            title: 'Uma ferramenta poderosa',
            description:
              '<strong>A Seleção de Data coloca você no dia certo para exercer determinadas atividades com mais facilidade e menos imprevistos.</strong><br /><br />O estudo da seleção de datas é personalizado, pois vamos analisar a qualidade energética do seu mapa natal frente à qualidade energética de determinados dias, <strong>buscando alinhar ambos da forma mais benéfica e produtiva para você.</strong><br /><br />Quem nunca se preparou cuidadosamente para um evento e mesmo assim tudo dá errado? Certamente a energia deste dia não estava em harmonia com a sua energia pessoal!',
            mediaPath: '/images/dateSelection/books.webp',
          },
          formTitle: 'Tome decisões no melhor momento da sua vida',
          badgeList: {
            title:
              'Aproveite a oportunidade de utilizar a energia de cada dia a seu favor',
            subtitle:
              'Conheça algumas situações onde a <strong>Seleção de Datas</strong> é muito benéfica:',
            badges: [
              ['Casamento', '/images/badges/dateSelection/casamento.webp'],
              [
                'Assinatura de contrato',
                '/images/badges/dateSelection/contrato.webp',
              ],
              [
                'Mudança residencial',
                '/images/badges/dateSelection/mudanca.webp',
              ],
              ['Viagens', '/images/badges/dateSelection/viagem.webp'],
              [
                'Abertura de empresa',
                '/images/badges/dateSelection/empresa.webp',
              ],
              ['Cirurgia', '/images/badges/dateSelection/cirurgia.webp'],
              [
                'Entrevista de trabalho',
                '/images/badges/dateSelection/trabalho.webp',
              ],
              [
                'Iniciar uma reforma',
                '/images/badges/dateSelection/reforma.webp',
              ],
            ],
          },
        },
        form: {
          namePlaceholder: 'Nome',
          emailPlaceholder: 'E-mail',
          options: {
            bazi: 'BaZi ou Análise dos 4 Pilares',
            iChing: 'I Ching',
            fengShui: 'Feng Shui',
            nineStar: 'Ki das 9 Estrelas',
            dateSelection: 'Seleção de Datas',
          },
          messagePlaceholder: 'Observações (opcional)',
          submitButton: 'Enviar',
        },
      },
      error: {
        notFound: {
          title: 'Ops!',
          description: 'Desculpe, algo deu errado ao carregar a página.',
        },
        form: {
          email: {
            invalid: '* E-mail inválido',
            required: '* E-mail obrigatório',
          },
          name: {
            required: '* Nome obrigatório',
          },
          message: {
            required: '* Mensagem obrigatória',
          },
        },
      },
      zodiacCards: {
        rat: {
          icon: '/icons/zodiac/rat.svg',
          title: 'Rato',
          years: [
            '1924',
            '1936',
            '1948',
            '1960',
            '1972',
            '1984',
            '1996',
            '2008',
            '2020',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'adaptável',
              'perspicaz',
              'otimista',
              'atencioso',
              'versátil',
              'extrovertido',
              'cauteloso',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: [
              'tímido',
              'teimoso',
              'exigente',
              'falta de persistência',
              'egocêntrico',
            ],
          },
        },
        ox: {
          icon: '/icons/zodiac/ox.svg',
          title: 'Búfalo',
          years: [
            '1925',
            '1937',
            '1949',
            '1961',
            '1973',
            '1985',
            '1997',
            '2009',
            '2021',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: ['leal', 'honesto', 'responsável', 'trabalhador', 'lógico'],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: ['introspectivo', 'conservador', 'teimoso', 'cauteloso'],
          },
        },
        tiger: {
          icon: '/icons/zodiac/tiger.svg',
          title: 'Tigre',
          years: [
            '1926',
            '1938',
            '1950',
            '1962',
            '1974',
            '1986',
            '1998',
            '2010',
            '2022',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'bravo',
              'apaixonado',
              'otimista',
              'gosta de desafios e aventuras amorosas',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: ['rebelde', 'excesso de confiança', 'teimoso', 'emotivo'],
          },
        },
        rabbit: {
          icon: '/icons/zodiac/rabbit.svg',
          title: 'Coelho',
          years: [
            '1927',
            '1939',
            '1951',
            '1963',
            '1975',
            '1987',
            '1999',
            '2011',
            '2023',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'otimista',
              'gracioso',
              'generoso',
              'de bom coração',
              'espirituoso e alerta',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: [
              'um pouco vaidoso',
              'emocionalmente instável',
              'facilmente satisfeito com o status quo',
            ],
          },
        },
        dragon: {
          icon: '/icons/zodiac/dragon.svg',
          title: 'Dragão',
          years: [
            '1928',
            '1940',
            '1952',
            '1964',
            '1976',
            '1988',
            '2000',
            '2012',
            '2024',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'determinado',
              'ambicioso',
              'independente',
              'enérgico',
              'sincero e goza de grande popularidade entre amigos',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: [
              'impaciente',
              'pouca tolerância e não gosta de admitir os erros',
            ],
          },
        },
        serpent: {
          icon: '/icons/zodiac/serpent.svg',
          title: 'Serpente',
          years: [
            '1929',
            '1941',
            '1953',
            '1965',
            '1977',
            '1989',
            '2001',
            '2013',
            '2025',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'calmo',
              'talentoso',
              'modesto',
              'perspicaz',
              'inteligente e tem muitas inspirações',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: ['indiferente', 'cético', 'possessivo e obstinado'],
          },
        },
        horse: {
          icon: '/icons/zodiac/horse.svg',
          title: 'Cavalo',
          years: [
            '1930',
            '1942',
            '1954',
            '1966',
            '1978',
            '1990',
            '2002',
            '2014',
            '2026',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'alegre',
              'talentoso',
              'perceptivo',
              'inteligente e popular no círculo social',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: [
              'excessivamente ambicioso e confiante',
              'às vezes pode ser esnobe também',
            ],
          },
        },
        goat: {
          icon: '/icons/zodiac/goat.svg',
          title: 'Cabra',
          years: [
            '1931',
            '1943',
            '1955',
            '1967',
            '1979',
            '1991',
            '2003',
            '2015',
            '2027',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'gentil',
              'simpático',
              'calmo',
              'criativo',
              'imaginativo',
              'sociável e atencioso',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: ['negativo', 'hesitante', 'pouco prático e às vezes teimoso'],
          },
        },
        monkey: {
          icon: '/icons/zodiac/monkey.svg',
          title: 'Macaco',
          years: [
            '1932',
            '1944',
            '1956',
            '1968',
            '1980',
            '1992',
            '2004',
            '2016',
            '2028',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'ativo',
              'perspicaz',
              'inteligente',
              'bem-humorado',
              'sociável',
              'capaz',
              'corajoso',
              'justo',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: [
              'fanfarrão',
              'astuto',
              'oportunista',
              'impaciente',
              'vaidoso',
            ],
          },
        },
        rooster: {
          icon: '/icons/zodiac/rooster.svg',
          title: 'Galo',
          years: [
            '1933',
            '1945',
            '1957',
            '1969',
            '1981',
            '1993',
            '2005',
            '2017',
            '2029',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'independente',
              'capaz',
              'caloroso',
              'respeito próprio',
              'mente rápida',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: ['impaciente', 'crítico', 'excêntrico', 'tacanho', 'egoísta'],
          },
        },
        dog: {
          icon: '/icons/zodiac/dog.svg',
          title: 'Cachorro',
          years: [
            '1934',
            '1946',
            '1958',
            '1970',
            '1982',
            '1994',
            '2006',
            '2018',
            '2030',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: ['corajoso', 'leal', 'responsável', 'inteligente', 'animado'],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: ['sensível', 'conservador', 'teimoso', 'emotivo'],
          },
        },
        pig: {
          icon: '/icons/zodiac/pig.svg',
          title: 'Porco',
          years: [
            '1935',
            '1947',
            '1959',
            '1971',
            '1983',
            '1995',
            '2007',
            '2019',
            '2031',
          ],
          strengths: {
            title: 'Pontos fortes',
            list: [
              'diligente',
              'sincero',
              'positivo',
              'responsável',
              'compassivo',
              'generoso',
            ],
          },
          weaknesses: {
            title: 'Pontos fracos',
            list: [
              'facilmente influenciável',
              'realista',
              'emocional',
              'autoindulgente',
            ],
          },
        },
      },
      contact: {
        title: 'Contato',
        formAdvice: 'Tem alguma duvida? Nos envie sua mensagem!',
        form: {
          name: 'Nome',
          email: 'E-mail',
          message: 'Mensagem',
          ctaButton: 'Enviar',
          successMessage: 'Mensagem enviada! Em breve entraremos em contato.',
        },
      },
      press: {
        title: 'Imprensa',
      },
      breadcrumbRoot: 'Home',
      privacyPolicy: {
        title: 'Política de privacidade',
        label: 'politica-de-privacidade',
        description:
          'Seja bem-vindo ao website <strong>BAZI BY MARINA</strong> (<a href="https://www.bazibymarina.com" target="_blank">https://www.bazibymarina.com/</a>).\n\nLeia atentamente estas informações, elas indicam como seus dados são coletados, utilizados e protegidos no site da <strong>BAZI BY MARINA</strong>. Ao fornecer Informações Pessoais ou navegar no site, você automaticamente concordará com as regras de utilização, proteção e segurança aqui estabelecidas.\n\nPara fins desta Política de Privacidade,"Usuários" ou "Vocês" são todos os indivíduos que de qualquer forma acessam o Site e/ou utilizam os serviços da <strong>BAZI BY MARINA</strong>.',
        content: [
          {
            title: '1. INFORMAÇÕES GERAIS',
            sectionContent:
              'A <strong>BAZI BY MARINA</strong> valoriza a privacidade dos seus visitantes e Usuários, para tal, esta Política de Privacidade descreve de que forma a <strong>BAZI BY MARINA</strong> protege a sua privacidade e seus Dados Pessoais, bem como coleta, trata e armazena as suas Informações Pessoais, nos termos da Lei Geral de Proteção de Dados e demais normativos vinculados ao tema.\n\nA presente Política de Privacidade se aplica a todos os Usuários que acessam ou utilizam o Site e/ou os Serviços da <strong>BAZI BY MARINA</strong> sejam eles online ou offline, incluindo sem se limitar ao uso de nosso site <a href="https://www.bazibymarina.com" target="_blank">https://www.bazibymarina.com/</a>.\n\nEsta Política de Privacidade é complementar para a garantia de privacidade dos Usuários, não pretendendo substituir os termos e condições de qualquer contrato ou cláusula de privacidade que o Usuário possa ter com a <strong>BAZI BY MARINA</strong>, nem quaisquer outros direitos que possam ter ao amparo de normativos, contratos e/ou documentos específicos.\n\nAo se registrar em nossa plataforma você aceita a nossa Política de Privacidade e nos indica que é maior de idade e tem capacidade plena e expressa para a aceitação dos termos e condições desta Política para todos os fins de direito. Caso não concorde, ainda que em parte, com nossa Política e/ou não se enquadre na descrição acima, deverá desconectar-se e interromper o uso dos nossos Serviços.',
          },
          {
            title: '2. DADOS PESSOAIS E COLETA DE INFORMAÇÕES',
            sectionContent:
              '“Dados Pessoais” são informações sobre uma pessoa natural identificada, ou identificável. Exemplos de Dados Pessoais são o nome completo, profissão, documento de identificação, endereço, e-mail, número de telefone, escolaridade, entre outros.\n\n“Tratamento” significa toda operação realizada com Dados Pessoais, como as que se referem à coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.\n\n“Titular” é a pessoa natural a quem se referem os Dados Pessoais que são objeto do Tratamento.',
          },
          {
            title: '2.1. INFORMAÇÕES DOS USUÁRIOS',
            sectionContent:
              'Na execução e no andamento de seus Serviços a <strong>BAZI BY MARINA</strong> precisa coletar algumas Informações Pessoais de seus Usuários, sendo certo, porém, que as informações coletadas são apenas aquelas necessárias ao fornecimento de Serviços satisfatórios. Essa coleta tem a finalidade principalmente de prestar serviços ao Usuário, mas também de personalizar e facilitar suas visitas futuras e de ajudar a <strong>BAZI BY MARINA</strong> a melhor direcionar suas estratégias e seu atendimento personalizado.\n\nA <strong>BAZI BY MARINA</strong> Coleta Dados Pessoais quando o Usuário se registra para um evento, envia informações para candidatar-se a uma vaga, quando preenche um formulário de “contato” via Website, quando nos envia documentos e informações em reuniões (virtuais ou presenciais) ou por meio de comunicações via WhatsApp, ligações ou e-mails.\n\nOs dados pessoais podem ser coletados diretamente com o Titular dos Dados, podem ser obtidos com alguém relacionado ao Titular do Dado (por exemplo, a empresa que o Usuário faz parte) ou podem ser acessados a partir de fontes publicamente acessíveis. Independentemente da origem do dado, o tratamento será regido por esta Política de Privacidade e o Usuário poderá entrar em contato conosco através do e-mail <a href="mailto:marina.caramez1@gmail.com" target="_blank">marina.caramez1@gmail.com</a> no caso de dúvidas.\n\nNos limites permitidos pela legislação aplicável, a <strong>BAZI BY MARINA</strong> poderá tratar os dados pessoais descritos abaixo.\n\na) Informações que você nos envia: Quando se registra nos nossos Serviços e/ou quando entra em contato conosco diretamente por qualquer canal de comunicação você poderá nos enviar Informações Pessoais como nome, endereço de e-mail, número de telefone, endereço residencial/comercial, Informações Pessoais de pagamento, outras Informações Pessoais que venha a incluir nas suas comunicações conosco e Informações Pessoais contidas em documentos de identificação escaneados (como uma cédula de identidade, carteira de habilitação, documentos oficiais de registro de empresas, entre outros);\n\nb) Informações que coletamos quando você usa os Serviços: Assim como acontece na maioria dos serviços de Internet, quando você visita nossos sites, faz downloads e/ou usa qualquer dos nossos Serviços, coletamos algumas informações automaticamente. Essas informações incluem a atividade de navegação e transmissão rápida de Visitantes e Usuários nos Serviços, mapas de calor e rolagens de sessões, Informações Pessoais não identificadoras relativas ao dispositivo do Visitante ou do Usuário, sistema operacional, navegador da internet, resolução da tela, idioma e configurações do teclado, provedor de serviços de internet, páginas encaminhadoras/de saída, marcações de data/tempo, endereços do Protocolo da Internet (IP), sites e dados de sequência de cliques (clickstream), dentre outras;\n\nc) Informações que coletamos de outras fontes: Podemos receber Informações Pessoais de você de fontes de terceiros, como i) provedores de segurança, provedores de detecção e prevenção de fraudes, por exemplo, para ajudar-nos a examinar Usuários associados a fraudes; e ii) parceiros de propaganda e marketing para monitorar, gerenciar e mensurar as nossas campanhas de anúncios.',
          },
          {
            title: '2.2. COOKIES',
            sectionContent:
              'O seu navegador de internet conta com a função interna de armazenar pequenos arquivos de texto – “cookies” – que contêm informações que permitem que um site reconheça a sua conta.\n\nO site da <strong>BAZI BY MARINA</strong> pode usar “cookies” e outras tecnologias similares. Essas tecnologias nos ajudam a entender melhor o comportamento dos Usuários e nos informam quais partes de nosso site as pessoas visitaram, além de medir e contribuir para a eficácia das atividades de marketing e pesquisas na web e personalizar a sua experiência.\n\nA maioria dos navegadores permite que você controle cookies, inclusive omiti-los ou não e como removê-los. Você pode configurar a maioria dos navegadores para notificá-lo caso receba um cookie ou pode optar por bloquear cookies no seu navegador. Se você quiser desabilitar os cookies, verifique com o fabricante/navegador para saber como bloqueá-los.',
          },
          {
            title: '3. FINALIDADE DO TRATAMENTO DE DADOS PESSOAIS',
            sectionContent:
              'O Tratamento dos seus Dados Pessoais pode ser realizado pela <strong>BAZI BY MARINA</strong> mediante o seu consentimento, quando aplicável, em diversos meios, por obrigação legal, regulatória, contratual ou outras formas. A <strong>BAZI BY MARINA</strong> pode solicitar que você forneça o consentimento escrito ou por qualquer meio que confirme tal consentimento, sempre que necessário.\n\nPodemos usar as suas Informações Pessoais para os seguintes propósitos:\n\na) Prestar e operar os Serviços da <strong>BAZI BY MARINA</strong>;\n\nb) Desenvolver, personalizar e melhorar os nossos Serviços com base nas preferências, experiências e dificuldades comuns ou pessoais dos Usuários;c) Analisar tendências e aprender sobre o comportamento do usuário no site e coletar informações demográficas sobre nossa base de Usuários como um todo;\n\nd) Mapear, definir, criar e desenvolver estratégias comerciais e de marketing, bem como operar, fornecer e melhorar nossos Serviços e publicidade;\n\ne) Proporcionar aos nossos Usuários atendimento ao cliente e suporte técnico contínuos e personalizados;\n\nf) Conseguir entrar em contato com os nossos Usuários por meio de notificações e mensagens promocionais gerais ou personalizadas relativas aos Serviços;\n\ng) Aprimorar a segurança da rede, inclusive para proteger nossos Serviços em benefício de todos os nossos Usuários;\n\nh) Propósitos internos, como auditoria, análise de dados e pesquisa para melhorar os Serviços e as comunicações com clientes da <strong>BAZI BY MARINA</strong>;\n\ni) Criar dados estatísticos agregados e outras Informações Pessoais agregadas e/ou inferidas sobre o seu perfil e de outros Usuários que acessem o site, permitindo o desenvolvimento de Serviços;\n\nj) Atender a obrigações legais a que a <strong>BAZI BY MARINA</strong> esteja sujeita, cumprir as leis e os regulamentos aplicáveis.\n\nk) Identificar e/ou oferecer-lhe conteúdo relevante sobre determinada preferência e/ou interesse manifestado por você à <strong>BAZI BY MARINA</strong>, incluindo, sem limitação, newsletters, eventos, convites, lembretes, notas de agradecimento, entre outros;\n\nl) Realizar pesquisa de satisfação e feedback sobre os nossos serviços e iniciativas.\n\nm) Compor banco de dados de fornecedores e prestadores de serviço da <strong>BAZI BY MARINA</strong>;\n\nn) Formar banco de dados de candidatos a vagas de emprego, estágio e prestação de serviços na <strong>BAZI BY MARINA</strong>;\n\no) Proteger, defender e administrar os interesses da <strong>BAZI BY MARINA</strong>;\n\nEventuais comentários feitos no site da <strong>BAZI BY MARINA</strong> poderão ser utilizados para fins publicitários; isso não constitui ofensa ou violação dos seus direitos, nos termos do inciso X, do artigo 5º da Constituição Federal. No entanto, o site da <strong>BAZI BY MARINA</strong> garante o uso de Informações Pessoais limitado à indicação do nome e sobrenome junto ao comentário realizado e que o Usuário poderá solicitar a exclusão do comentário a qualquer tempo mediante envio de comunicação para a <strong>BAZI BY MARINA</strong> através do canal <a href="mailto:marina.caramez1@gmail.com" target="_blank">marina.caramez1@gmail.com</a>.',
          },
          {
            title: '4. COMPARTILHAMENTO E TRATAMENTO DE INFORMAÇÕES PESSOAIS',
            sectionContent:
              'A <strong>BAZI BY MARINA</strong> não comercializará os seus Dados Pessoais. Entretanto, seus Dados Pessoais podem ser compartilhados ou transferidos a terceiros, no Brasil e/ou no exterior, nas seguintes situações e nos limites exigidos e autorizados pela Lei:\n\na) Com os seus clientes e parceiros quando necessário e/ou apropriado à prestação de Serviços e soluções relacionadas que complementam, facilitam e aprimoram os Serviços da <strong>BAZI BY MARINA</strong>. Esses serviços podem ser de hospedagem e colocação de servidores, comunicações e redes de apresentação de conteúdo (CDNs), serviços de segurança cibernética e de dados, serviços de processamento de cobrança e pagamentos, registradores de nomes de domínio, serviços de detecção e prevenção de fraudes, analítica da internet, serviços de distribuição e monitoramento de e-mails, serviços de gravação e acesso remoto a sessões, serviços de mensuração de desempenho, otimização de dados e marketing, provedores de conteúdo e os nossos consultores jurídicos e financeiros;\n\nb) Com as empresas e indivíduos contratados para a execução de determinadas atividades e serviços em nome da <strong>BAZI BY MARINA</strong>;\n\nc) Com suas empresas subsidiárias diretas e indiretas;\n\nd) Com fornecedores e parceiros para consecução dos Serviços contratados com a <strong>BAZI BY MARINA</strong>;\n\ne) Para propósitos administrativos como: pesquisa, planejamento, desenvolvimento de Serviços, segurança e gerenciamento de risco;\n\nf) A <strong>BAZI BY MARINA</strong> também pode compartilhar as suas Informações Pessoais com terceiros para outros propósitos por sua orientação adicional ou com a sua aprovação expressa;\n\ng) Se a <strong>BAZI BY MARINA</strong> passar por alterações de controle, inclusive por meio de fusão, aquisição ou compra de substancialmente todos os seus bens, as suas Informações Pessoais podem ser compartilhadas com as partes envolvidas em tal evento.\n\nNas hipóteses de compartilhamento de Dados Pessoais com terceiros, todos os sujeitos mencionados nos itens “a” a “g” deverão utilizar os Dados Pessoais partilhados de maneira consistente e de acordo com os propósitos para os quais foram coletados (ou com os quais o Usuário consentiu previamente) e de acordo com o que foi determinado por esta Política de Privacidade, outras declarações de privacidade de website ou países, e todas as leis de privacidade e proteção de dados aplicáveis.\n\nEm todas as hipóteses, a <strong>BAZI BY MARINA</strong> se compromete a compartilhar estritamente os Dados Pessoais que se fizerem necessários ao cumprimento da respectiva finalidade.',
          },
          {
            title: '5. MOTIVOS LEGAIS PARA A DIVULGAÇÃO DE DADOS',
            sectionContent:
              'Em certas circunstâncias, a <strong>BAZI BY MARINA</strong> poderá divulgar Dados Pessoais, na medida necessária ou apropriada, para órgãos governamentais, consultores e outros terceiros com o objetivo de cumprir com a legislação aplicável ou com solicitações judiciais, como intimações, processos judiciais, mandados de busca ou ordens judiciais, ou ainda, se a <strong>BAZI BY MARINA</strong> acreditar de boa-fé que tal ação seja necessária para:\n\na) Cumprir com uma legislação que exija tal divulgação;\n\nb) Investigar, impedir ou tomar medidas relacionadas a atividades ilegais suspeitas ou reais ou para cooperar com órgãos públicos ou para proteger a segurança nacional;\n\nc) Execução de seus contratos;\n\nd) Investigar e se defender contra quaisquer reivindicações ou alegações de terceiros;\n\ne) Proteger a segurança ou a integridade dos Serviços;\n\nf) Exercer ou proteger os direitos, a propriedade e a segurança da <strong>BAZI BY MARINA</strong> e suas empresas coligadas;\n\ng) Proteger os direitos e a segurança pessoal de seus funcionários, Usuários ou do público;\n\nA <strong>BAZI BY MARINA</strong> poderá contestar essas demandas se julgar que as solicitações são excessivas, vagas ou feitas por autoridades incompetentes.',
          },
          {
            title:
              '6. PRIVACIDADE, SEGURANÇA E PROTEÇÃO DE INFORMAÇÕES PESSOAIS',
            sectionContent:
              'A <strong>BAZI BY MARINA</strong> e os terceiros com os quais os seus Dados Pessoais venham a ser eventualmente compartilhados observam os padrões de segurança necessários à prevenção e remediação do acesso desautorizado de Dados Pessoais, empregando os meios aplicáveis e padrões de segurança recomendados para protegê-los, na medida em que forem técnica e operacionalmente viáveis.\n\nA <strong>BAZI BY MARINA</strong> e seus fornecedores utilizam procedimentos de segurança para proteger a confidencialidade, segurança e integridade de seus Dados Pessoais, prevenindo a ocorrência de eventuais danos em virtude do tratamento desses dados.\n\nEmbora a <strong>BAZI BY MARINA</strong> utilize medidas de segurança e monitore seu sistema para verificar vulnerabilidades e ataques para proteger seus Dados Pessoais contra divulgação não autorizada, mau uso ou alteração, o Usuário entende e concorda que não há garantias de que as informações não poderão ser acessadas, divulgadas, alteradas ou destruídas por violação de qualquer uma das proteções físicas, técnicas ou administrativas.',
          },
          {
            title: '7. RETENÇÃO DE DADOS',
            sectionContent:
              'A <strong>BAZI BY MARINA</strong> poderá armazenar os Dados Pessoais dos Usuários pelo tempo necessário ao cumprimento das finalidades citadas nesta política, assim como para o cumprimento da legislação ou regulação aplicável, conforme o caso. Para a determinação da forma e duração do Tratamento dos seus Dados Pessoais pela <strong>BAZI BY MARINA</strong>, será considerada a natureza dos seus Dados Pessoais fornecidos, assim como a finalidade do Tratamento. Uma vez que a finalidade do Tratamento dos seus Dados Pessoais tenha sido exaurida, eles serão eliminados.\n\nTambém ocorrerá o fim do tratamento de dados e a eliminação dos dados pessoais quando o Titular dos Dados estiver em seu direito de solicitar o término do tratamento e a exclusão de seus dados pessoais e o fizer, e/ou quando houver uma determinação legal neste sentido.\n\nA <strong>BAZI BY MARINA</strong> poderá vir a manter seus Dados Pessoais após receber seu pedido de exclusão ou após o fim da finalidade caso seja necessário para cumprimento de obrigações legais, resolver disputas, manter a segurança, evitar fraudes e abuso e garantir o cumprimento de contratos.\n\nPara mais informações sobre onde e quanto tempo seus Dados Pessoais serão armazenados, bem como sobre mais informações a respeito dos seus direitos de exclusão e portabilidade, contate <a href="mailto:marina.caramez1@gmail.com" target="_blank">marina.caramez1@gmail.com</a>.',
          },
          {
            title: '8. DIREITOS DO TITULAR DOS DADOS PESSOAIS',
            sectionContent:
              'A <strong>BAZI BY MARINA</strong> reconhece e concorda que toda pessoa natural tem assegurada a titularidade de seus Dados Pessoais e garantidos os direitos fundamentais de liberdade, de intimidade e de privacidade, nos termos da legislação e, por isso, garante que o titular dos Dados Pessoais tem direito a obter, a qualquer momento e mediante requisição:\n\na) Confirmação de tratamento de dados: o Usuário pode solicitar confirmação se é realizado pela <strong>BAZI BY MARINA</strong> e/ou terceiros autorizados o tratamento de seus dados, inclusive após o término da sua relação com a <strong>BAZI BY MARINA</strong>;\n\nb) Obtenção de informação sobre quais Dados Pessoais são armazenados e de alguma outra forma tratados pela <strong>BAZI BY MARINA</strong>;\n\nc) Exclusão de dados: o Usuário pode solicitar a exclusão de todos ou alguns dos seus Dados Pessoais (por exemplo, se eles não são mais necessários para lhe fornecer os Serviços);\n\nd) Alteração ou correção de dados: o Usuário pode editar ou solicitar a edição dos seus Dados Pessoais. O Usuário também pode solicitar atualizações, alterações ou correções de seus dados, principalmente se eles estiverem incorretos, incompletos ou desatualizados;\n\ne) Colocar objeções, limites ou restrições ao uso de dados: o Usuário pode solicitar a interrupção do uso de todos ou alguns de seus Dados Pessoais, ou limitar a nossa utilização de tais dados, destacando-se que a <strong>BAZI BY MARINA</strong> poderá tratar os Dados Pessoais de acordo as finalidades listadas no tópico 3;\n\nf) Acesso aos dados: o Usuário pode solicitar uma cópia dos seus Dados Pessoais e dos dados que o Usuário forneceu em um formato legível sob a forma impressa ou por meio eletrônico.\n\nHá circunstâncias legais que podem restringir o exercício de alguns direitos previstos em lei, especialmente quando o fornecimento das informações puder revelar algum segredo de negócio da <strong>BAZI BY MARINA</strong>.\n\nO Usuário pode fazer as solicitações listadas acima entrando em contato pelo e-mail <a href="mailto:marina.caramez1@gmail.com" target="_blank">marina.caramez1@gmail.com</a> e estes pedidos serão considerados de acordo com as leis aplicáveis.',
          },
          {
            title: '9. COMUNICAÇÕES DA BAZI BY MARINA',
            sectionContent: '',
          },
          {
            title: '9.1. MENSAGENS PROMOCIONAIS',
            sectionContent:
              'Podemos usar as suas Informações Pessoais para enviar-lhe conteúdo e mensagens promocionais por e-mail, mensagens de texto, notificações na nossa plataforma, chamadas de marketing e formas similares de comunicação da <strong>BAZI BY MARINA</strong> ou dos nossos parceiros (atuando em representação da <strong>BAZI BY MARINA</strong>) por tais meios.\n\nCaso não deseje receber essas mensagens ou chamadas promocionais, você pode notificar a <strong>BAZI BY MARINA</strong> a qualquer momento ou seguir as instruções de “cancelar a inscrição” ou PARAR contidas nas comunicações promocionais que receber.',
          },
          {
            title: '9.2. MENSAGENS DE SERVIÇO',
            sectionContent:
              'A <strong>BAZI BY MARINA</strong> também poderá entrar em contato com você com informações importantes relativas aos nossos Serviços ou ao seu uso deles. É importante que você sempre consiga recebePrivacidader essas mensagens, por essa razão, você não pode cancelar o recebimento de tais Mensagens de Serviço a menos que deixe de ser Usuários da <strong>BAZI BY MARINA</strong>.',
          },
          {
            title: '10. LIGAÇÕES COM SITES DE TERCEIROS',
            sectionContent:
              'O site da <strong>BAZI BY MARINA</strong> pode possuir ligações/links para/com outros sites, os quais, a nosso ver, podem conter informações/ ferramentas úteis para os nossos Usuários.\n\nRessaltamos expressamente que a nossa política de privacidade não é aplicável a sites de terceiros, pelo que, caso o Usuários visite outro site a partir do site da <strong>BAZI BY MARINA</strong>, deverá ler e concordar com a política de privacidade do referido site.\n\nA <strong>BAZI BY MARINA</strong> não se responsabiliza, de nenhuma forma e sob nenhuma alegação, pela política de privacidade e/ou conteúdo presente nesses sites.',
          },
          {
            title: '11. ALTERAÇÕES E REVISÕES À POLÍTICA DE PRIVACIDADE',
            sectionContent:
              'A <strong>BAZI BY MARINA</strong> se reserva o direito de, a qualquer momento, modificar, alterar, acrescentar ou remover partes desta política, mediante publicação da versão atualizada nesta página.\n\nO uso do Site ou o fornecimento de Dados Pessoais por qualquer outro meio pressupõe a sua concordância com a presente Política de Privacidade.',
          },
          {
            title: '12. CONTATO',
            sectionContent:
              'Em caso de dúvida com relação às disposições constantes desta Política de Privacidade, ou em caso de qualquer solicitação que você tenha interesse em fazer a respeito de seus dados, entre em contato conosco através do e-mail <a href="mailto:marina.caramez1@gmail.com" target="_blank">marina.caramez1@gmail.com</a>.',
          },
          {
            title: '13. FORO',
            sectionContent:
              'A presente Política de Privacidade será regida e interpretada segundo a legislação brasileira, sendo eleito o Foro da Comarca Central do Rio de Janeiro para dirimir qualquer litígio ou controvérsia envolvendo o presente documento.\n\nEsta Política de Privacidade entra em vigor em [27/04/2023].',
          },
        ],
      },
      pagination: {
        next: 'Próximo',
        previous: 'Anterior',
      },
      cookies: {
        title: 'Este site utiliza cookies.',
        description:
          'Coletamos dados para melhorar o desempenho e segurança do site. Para mais informações, consulte a nossa',
        accept: 'Aceitar',
      },
      loading: 'Carregando...',
      share: 'Compartilhe',
      ecmaNotSupported:
        'Este navegador não suporta completamente nosso site. \n\nPra que possa navegar sem problemas, recomendamos que atualize seu navegador ou tente usar outro.',
    },
  },
};

export { messages };
